import React from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom'
import './App.css';
import Navbar from './components/mdbnav.js'
import Home from './pages/Home';
import TVs from './pages/TVs';
import Laptops from './pages/Laptops';
import Tablets from './pages/Tablets';
import Phones from './pages/Phones';
import Consoles from './pages/Consoles';
import Accessories from './pages/Accessories';
import Cart from './components/Cart';
import Footer from './components/Footer';
import 'bootstrap/dist/css/bootstrap.min.css';
import details from './pages/details';


function App() {
  return (
    <div className="App">
      <Router>
        <div>
          <Navbar/>
            <Switch>
              <Route exact path='/' component={Home}/>
              <Route exact path='/TVs' component={TVs}/>
              <Route exact path='/Laptops' component={Laptops}/>
              <Route exact path='/Tablets' component={Tablets}/>
              <Route exact path='/Phones' component={Phones}/>
              <Route exact path='/Consoles' component={Consoles}/>
              <Route exact path='/Accessories' component={Accessories}/>
              <Route exact path='/Cart' component={Cart}/>
              <Route exact path='/product/detail' component={details}/>
            </Switch>
          <Footer/>
        </div>
      </Router>
    </div>
  );
}

export default App;
